import { render, staticRenderFns } from "./QrCodeWallet.vue?vue&type=template&id=b294b9a4&"
import script from "./QrCodeWallet.vue?vue&type=script&lang=js&"
export * from "./QrCodeWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports